import { render, staticRenderFns } from "./BToggleableContent.vue?vue&type=template&id=8a57d71a&"
import script from "./BToggleableContent.vue?vue&type=script&lang=js&"
export * from "./BToggleableContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports